import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Container } from "react-bootstrap";
import { Link } from 'react-router-dom';
import { checkCredentialsAPI, getcoursesbyinstituteid, passwordresetsendemail, createPlanCheckoutSession, verifyTeacherAccessCode } from '../../common/API'
import { toast } from 'react-toastify';
import { APP_URL, WEBSITE_URL, getIsPrivate, setCookies, setCourse, setScannedInClassSession, getScannedInClassSessionUrl } from '../../common/Functions';
import { isNil, isEmpty } from 'lodash';
import './Login.scss';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from 'universal-cookie';

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loginEmail: '',
            validLoginEmail: false,
            password: '',
            showPassword: false,
            redirectToQue: '',
            sessionId: '',
            isPrivate: false,
            showHeader: true,
            isForgotPasswordClicked: false,
            loading: false,
            // Sign In is in flight. The credential check is followed by a course lookup and
            // then a full page navigation, so the button sits idle for a noticeable beat --
            // long enough that students click it again and submit twice.
            signingIn: false,
            hasAutoLogin: true,
            showTrialExpired: false,
            // Class-Key (enrollment) student whose 14-day grace lapsed unpaid, or
            // any other entitlement-expired cohort: login is blocked, so this is
            // the ONLY place they can pay (the in-app grace banner is unreachable).
            showAccessExpired: false,
            accessExpiredPaying: false,
            // Locked-out (expired) student settling with a bookstore code instead
            // of paying online — the in-app grace banner is unreachable once blocked.
            showRedeemFromLogin: false,
            redeemCode: '',
            redeemingFromLogin: false,
            redeemError: '',
            // Viewport position of the /login card when it hangs off the navbar Login button.
            cardPos: null
        }
    }

    componentWillMount() {
        document.cookie = "hasTestPrep=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        this.setState({ isPrivate: getIsPrivate() })
    }

    componentDidMount() {
        this.getURLParams()
        if (this.props.showHeader !== undefined) {
            this.setState({ showHeader: this.props.showHeader })
        }
        if (this.props.showHeader !== false) {
            this.positionCard()
            window.addEventListener('resize', this.positionCard)
            // Web fonts can shift the navbar after first paint.
            window.addEventListener('load', this.positionCard)
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.positionCard)
        window.removeEventListener('load', this.positionCard)
    }

    /**
     * On the /login page the card is drawn as a popover hanging off the navbar's
     * Login button. The navbar is a separate component, so find whichever Login
     * button is currently visible and pin the card under it. Below tablet width
     * (or with no button on screen) cardPos stays null and the card is centred.
     */
    positionCard = () => {
        let anchor = null
        if (window.innerWidth >= 768) {
            anchor = Array.from(document.querySelectorAll('.Nav-Container .app-login-btn'))
                .find(el => el.offsetParent !== null) || null
        }
        if (anchor === null) {
            this.setState({ cardPos: null })
            return
        }
        const rect = anchor.getBoundingClientRect()
        this.setState({
            cardPos: {
                top: rect.bottom + 14,
                right: Math.max(16, window.innerWidth - rect.right),
                arrowRight: Math.max(12, rect.width / 2 - 7)
            }
        })
    }

    handleCloseCard = () => {
        if (this.props.onClose) {
            this.props.onClose()
        } else {
            this.props.history.push('/')
        }
    }

    getURLParams = () => {
        const queryParameters = new URLSearchParams(window.location.search.substring(1));
        let assignmentId = ''
        let assignmentStr = '';
        let paymentStatus = ''
        // Set by the app when a not-logged-in student scans the in-class QR code. Kept
        // above the `size` check, which is undefined on iOS Safari before 17.
        if (!isNil(queryParameters.get('fromInClass')) && !isNil(queryParameters.get('sessionId'))) {
            setScannedInClassSession(queryParameters.get('sessionId'));
        }
        if (!isNil(queryParameters) && queryParameters.size > 0) {
            if (!isNil(queryParameters.get("external_id"))) {
                if (!isNil(queryParameters.get('course_id'))) {
                    setCourse(queryParameters.get('course_id'));
                    // setCourse writes `menuselecteditem` with no domain, so it is a
                    // host-only cookie on this origin and the SPA on app.aiplato.ai can
                    // never read it. Carry the launched course across the origin boundary
                    // in the redirect URL instead (see appUrlForLaunch below). Do NOT add
                    // `domain` to setCourse to "fix" this — a second menuselecteditem on
                    // .aiplato.ai shadows the app's own cookie and breaks course switching.
                    const launchCourseId = parseInt(queryParameters.get('course_id'), 10);
                    if (!isNaN(launchCourseId) && launchCourseId > 0) {
                        this.launchCourseId = launchCourseId;
                    }
                }
                if (!isNil(queryParameters.get('assignment_id'))) {
                    assignmentId = queryParameters.get('assignment_id')
                }
                if (!isNil(queryParameters.get('assignment_str'))) {
                    assignmentStr = queryParameters.get('assignment_str')
                }
                if (!isNil(queryParameters.get('registered'))) {
                    paymentStatus = (queryParameters.get('registered'))
                }
                this.getEarlyAccessHandler(null, queryParameters.get("external_id"), assignmentId, !isNil(queryParameters.get('role')) ? queryParameters.get('role') : '', !isNil(queryParameters.get('registered')) ? (queryParameters.get('registered') === 'not_started' || queryParameters.get('registered') === 'expired') ? false : true : true, assignmentStr, paymentStatus);
                return;
            } else {
                this.setState({ hasAutoLogin: false })
            }
            if (!isNil(queryParameters.get("sessionId"))) {
                this.setState({ sessionId: queryParameters.get("sessionId") })
            }
            if (!isNil(queryParameters.get('fromQue'))) {
                this.setState({ redirectToQue: queryParameters.get('fromQue').toString() });
            }

        } else {
            this.setState({ hasAutoLogin: false })
        }

    }
    validateEmail = (input) => {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        return emailPattern.test(input);
    }

    handleEmailChange = (event) => {
        const newEmail = event.target.value;
        this.setState({ loginEmail: newEmail });
        this.setState({ validLoginEmail: this.validateEmail(newEmail) });
    }

    togglePasswordVisibility = () => {
        this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
    }

    // Pay for Semester Access from the login screen when access has expired.
    // The entered email identifies the account; the backend resolves the real
    // per-course price and, on success, promotes the entitlement so the student
    // can log back in.
    handlePaySemesterFromLogin = () => {
        const email = this.state.loginEmail.trim().toLowerCase();
        this.setState({ accessExpiredPaying: true });
        const checkout = {
            plan_type: 'semester',
            email: email,
            origin: window.location.origin
        };
        // On a Moodle launch, price and provision the launched course. Without it
        // the backend promotes whichever grace row was touched last, which for a
        // student in two paid courses can be the wrong one.
        if (this.launchCourseId) {
            checkout.course_id = this.launchCourseId;
        }
        createPlanCheckoutSession(checkout)
            .then(res => {
                if (res.data && res.data.url) {
                    window.location.href = res.data.url;
                } else {
                    this.setState({ accessExpiredPaying: false });
                    toast.error(res.data?.error || "Couldn't start checkout. Please try again.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: true,
                        style: { borderRadius: "10px" }
                    });
                }
            })
            .catch(err => {
                this.setState({ accessExpiredPaying: false });
                toast.error("Something went wrong starting checkout. Please try again.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: true,
                    style: { borderRadius: "10px" }
                });
                console.error(err.message);
            });
    }

    // Redeem a bookstore access code from the login screen for a locked-out
    // (access-expired) student. Upgrades their entitlement (expired -> bookstore)
    // and consumes the single-use code, then re-attempts login automatically.
    handleRedeemFromLogin = (e) => {
        if (e) { e.preventDefault(); }
        const trimmed = (this.state.redeemCode || '').trim();
        if (!trimmed) {
            this.setState({ redeemError: 'Please enter your access code.' });
            return;
        }
        this.setState({ redeemingFromLogin: true, redeemError: '' });
        verifyTeacherAccessCode({
            first_name: '',
            last_name: '',
            email: this.state.loginEmail.trim().toLowerCase(),
            access_code: trimmed,
            share_report_with_professor: true
        })
            .then(res => {
                const ok = res.data && (res.data.Success === true || res.data.Success === 'Success');
                if (ok) {
                    // Entitlement upgraded to bookstore; retry login automatically.
                    this.setState({ redeemingFromLogin: false, showAccessExpired: false, showRedeemFromLogin: false, redeemCode: '' });
                    toast.success('Code redeemed! Signing you in…', {
                        position: toast.POSITION.BOTTOM_RIGHT, autoClose: true, style: { borderRadius: '10px' }
                    });
                    // A Moodle-launched student typed no password, so a password
                    // retry would silently do nothing. Re-run the launch instead:
                    // the URL still carries external_id, course and assignment.
                    if (new URLSearchParams(window.location.search).get('external_id')) {
                        window.location.reload();
                        return;
                    }
                    this.getEarlyAccessHandler();
                } else {
                    this.setState({ redeemingFromLogin: false, redeemError: (res.data && res.data.message) || 'Could not redeem this code.' });
                }
            })
            .catch(err => {
                const msg = err.response && err.response.data && err.response.data.message;
                this.setState({ redeemingFromLogin: false, redeemError: msg || 'Could not redeem this code. Please try again.' });
            });
    }
    // encryptPassword = (password) => {
    //     return CryptoJS.AES.encrypt(password, "sDJwT4ZG2NBj4wOa3rR3A76jtzZqZ9SkZ8uQ4V2s5Go=").toString();
    // };

    getEarlyAccessHandler = (e, external_id = '', assignment_id = '', role = '', registered = true, assignmentCollection = '', paymentStatus = '') => {
        if (!isNil(e)) {
            e.preventDefault()
        }

        if (this.state.password.length > 0 || external_id !== '') {
            let data = external_id === '' ? { 'email': this.state.loginEmail.trim().toLowerCase(), password: (this.state.password.trim()), signupmethod: "aiPlato" } : { 'external_id': external_id }

            // Cleared again on every branch below that leaves the user ON this page. The
            // branches that navigate away deliberately keep it raised: the button must stay
            // busy through the redirect, not flick back to "Sign In" on a page about to go.
            this.setState({ signingIn: true })
            checkCredentialsAPI(data).then(res => {
                if (res.status === 200) {
                    if (res.data['found'] === true && res.data.status === "Active") {
                        this.addValidationCookie(res.data.email.trim().toLowerCase(),
                            res.data.userId,
                            res.data.role,
                            res.data.name,
                            res.data.status,
                            res.data.tryThisPinsEnabled,
                            res.data.QATestFlag,
                            this.convertDurationToSeonds(res.data.timeLimit),
                            res.data.institute_id,
                            res.data.institute_name,
                            (isNil(res.data.user_timezone) || isEmpty(res.data.user_timezone)) ? "America/New_York" : res.data.user_timezone,
                            res.data.isDemoUser,
                            res.data.isPtTeacher,
                            res.data.menuselecteditem,
                            res.data.isAdminUser,
                            res.data.userPlan,
                            res.data.user_professor_id,
                            res.data.isTA,
                            res.data.isinternaluser,
                            registered,
                            assignmentCollection,
                            paymentStatus,
                            external_id,
                            res.data.signupmethod || '',
                            res.data.has_institute_access === true
                        )

                        this.getUserCourse(res, external_id, assignment_id, role, registered, assignmentCollection, paymentStatus)

                    }
                    else if (res.data['trial_expired'] === true) {
                        toast.error("Your 7-day free trial has expired. Please subscribe to continue using aiPlato.", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            autoClose: 8000,
                            style: { borderRadius: "10px" }
                        });
                        this.setState({ signingIn: false, showTrialExpired: true, shoowearlyaccess: false, showemaildiv: true })
                    }
                    else if (res.data['access_expired'] === true) {
                        toast.error(res.data.error || "Your access has expired. Please pay for Semester Access to continue.", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            autoClose: 8000,
                            style: { borderRadius: "10px" }
                        });
                        // A Moodle launch (external_id) keeps hasAutoLogin=true, which
                        // hides the whole form -- and the Pay / Redeem panel inside it --
                        // leaving only the toast. Show the form, pre-filled with the
                        // account email the server returned, so the student can settle.
                        const expiredState = { signingIn: false, showAccessExpired: true, showTrialExpired: false, shoowearlyaccess: false, showemaildiv: true, hasAutoLogin: false };
                        if (res.data.email) {
                            expiredState.loginEmail = res.data.email.trim().toLowerCase();
                        }
                        this.setState(expiredState)
                    }
                    else if (res.data['isexpired'] === true) {
                        toast.error("Your account is expired, please get in touch with support team!", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            autoClose: true,
                            style: { borderRadius: "10px" }
                        });
                        this.setState({ signingIn: false, shoowearlyaccess: true, showemaildiv: false })
                    }
                    else {
                        toast.error("Please enter valid email id and password.", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                            autoClose: true,
                            style: { borderRadius: "10px" }
                        });
                        this.setState({ signingIn: false, shoowearlyaccess: false, showemaildiv: true })
                    }
                } else {
                    this.setState({ signingIn: false })
                    toast.error("Server Error !", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        autoClose: true,
                        style: { borderRadius: "10px" }
                    });
                }
            }).catch(err => {
                console.error(err.message)
                this.setState({ signingIn: false })
                toast.error("Please enter valid email id and password.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    autoClose: true,
                    style: { borderRadius: "10px" }
                });
            })
        }

    }
    addValidationCookie = (email, userId, role, name, status, tryThisPinsEnabled, QATestFlag, timeLimit, institute_id, institute_name, usertimezone, isDemoUserFlagged, isPtTeacher, menuselecteditem, isAdminUser, userPlan, user_professor_id, isTA, isinternaluser, registered, assignmentCollection, paymentStatus, external_id, signupmethod, hasInstituteAccess) => {
        setCookies(email, userId, role, name, status, tryThisPinsEnabled, QATestFlag, timeLimit, institute_id, institute_name, usertimezone, "", false, isDemoUserFlagged, isPtTeacher, menuselecteditem, isAdminUser, userPlan, user_professor_id, isTA, isinternaluser, registered, assignmentCollection, paymentStatus, external_id, signupmethod, hasInstituteAccess)
    }

    /** Course the student launched into from Canvas/Moodle; set by getURLParams. */
    launchCourseId = null;

    /**
     * Build an app URL, appending the launched course when this login came from an
     * LTI launch. The SPA consumes `launch_course_id` once and strips it from the
     * URL (see aiplato-frontend common/Functions.getLtiLaunchCourseIdFromUrl), so it
     * never survives to a reload and never competes with the course switcher.
     */
    appUrlForLaunch = (path) => {
        if (this.launchCourseId === null || this.launchCourseId === undefined) {
            return APP_URL + path;
        }
        const separator = path.indexOf('?') === -1 ? '?' : '&';
        return `${APP_URL}${path}${separator}launch_course_id=${this.launchCourseId}`;
    }

    /**
     * Hand the Professor's saved course to the app for the resumed page. Like the other
     * session cookies it goes on the shared parent domain; it is short-lived, and the app
     * reads it once, applies it only if the Professor still has that course, then deletes
     * it (aiplato-frontend common/lastPageTracker.consumeResumeCourseId). Any other login
     * clears it so a stale value can never pick the course.
     */
    setResumeCourseCookie = (courseId) => {
        const cookies = new Cookies();
        const hostnameParts = window.location.hostname.split('.');
        const domainName = hostnameParts.length > 1 ? hostnameParts[hostnameParts.length - 2] + "." + hostnameParts[hostnameParts.length - 1] : hostnameParts[hostnameParts.length - 1];
        if (courseId !== null && courseId !== undefined && courseId !== '') {
            cookies.set('resumeCourseId', courseId, { path: '/', domain: domainName, maxAge: 120 });
        } else {
            cookies.remove('resumeCourseId', { path: '/', domain: domainName });
        }
    }

    getUserCourse = (res, external_id, assignment_id, role, registered, assignmentCollection, paymentStatus) => {
        const reqData = { params: { "user_id": res.data.userId } };
        getcoursesbyinstituteid(reqData)
            .then(response => {
                if (response.data.data !== undefined && response.data.data !== null) {
                    let cookies = new Cookies();
                    let menuselecteditem = cookies.get("menuselecteditem")
                    let selectedCourse = response.data.data.find(element => element.value === parseInt(menuselecteditem))
                    if (menuselecteditem !== undefined && menuselecteditem !== null && menuselecteditem !== "") {
                        let hasExistingSelectedItem = false
                        response.data.data.forEach(element => {
                            if (element.value === parseInt(menuselecteditem)) {
                                hasExistingSelectedItem = true;
                                cookies.set('hasTestPrep', element.enabletestprep, { path: '/' })
                            }
                        });

                        if (!hasExistingSelectedItem) {
                            if (response.data.data.length > 0) {
                                cookies.set('menuselecteditem', response.data.data[0].value, { path: '/' })
                                cookies.set('hasTestPrep', response.data.data[0].enabletestprep, { path: '/' })
                                selectedCourse = response.data.data[0]
                            }
                        }
                    }
                    else {
                        if (response.data.data.length > 0) {
                            cookies.set('menuselecteditem', response.data.data[0].value, { path: '/' })
                            cookies.set('hasTestPrep', response.data.data[0].enabletestprep, { path: '/' })
                            selectedCourse = response.data.data[0]
                        }
                    }

                    // Cookied here (same as hasTestPrep above) so the frontend app can read
                    // is_independent_course before its own getcoursesbyinstituteid call
                    // resolves, instead of waiting on that round-trip to decide whether to
                    // show the independent-course dashboard.
                    cookies.set('isIndependentCourse', selectedCourse?.is_independent_course === true, { path: '/' })

                    const scannedInClassSessionUrl = getScannedInClassSessionUrl()
                    // Professor opted in to "continue from last visited page". The backend only
                    // returns resumeRoute after validating it; LTI launches keep their own target.
                    const resumeRoute = res.data.role === 'Professor' && external_id === '' ? res.data.resumeRoute : null
                    this.setResumeCourseCookie(null)
                    if (this.state.redirectToQue === 'true') {
                        window.location.href = `/question/?sessionId=${this.state.sessionId}`
                    }
                    // Back to the session they scanned, with the code already filled in.
                    else if (scannedInClassSessionUrl !== '') {
                        window.open(scannedInClassSessionUrl, '_self')
                    }
                    else if (selectedCourse && selectedCourse.is_independent_course) {
                        window.open(this.appUrlForLaunch(""), '_self')
                    }
                    else if (resumeRoute) {
                        this.setResumeCourseCookie(res.data.resumeCourseId)
                        window.open(APP_URL + String(resumeRoute).replace(/^\/+/, ''), '_self')
                    }
                    else if (Number(res.data.institute_id) !== 1) {
                        if (assignment_id === '' || role.toLowerCase() === 'professor') {
                            window.open(this.appUrlForLaunch("assignments"), '_self')
                        } else if (!registered && external_id !== '' && assignment_id !== '') {
                            window.open(this.appUrlForLaunch("payment/" + assignment_id), '_self')
                        } else {
                            window.open(this.appUrlForLaunch("assignmentdetails/" + assignment_id), '_self')
                        }
                    } else {
                        window.open(APP_URL + "curriculum-problems", '_self')

                        this.setState({ email: '', password: '', showPassword: false });
                        this.setState({ shoowearlyaccess: true, showemaildiv: false, showdropdown: true, studenttutorvalue: "", buttontext: "Request Access" })
                    }

                } else {
                    // No course list came back, so none of the branches above navigate and the
                    // user stays here. Drop the busy state, otherwise Sign In spins forever.
                    this.setState({ signingIn: false })
                    toast.error("We could not load your courses. Please try again, or contact support@aiplato.ai.", {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        style: { borderRadius: "10px" }
                    });
                }
            })
            .catch(err => {
                console.error(err.message)
                this.setState({ loading: false, signingIn: false })
                toast.error("We could not load your courses. Please try again, or contact support@aiplato.ai.", {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    style: { borderRadius: "10px" }
                });
            })
    }
    convertDurationToSeonds = (duration) => {
        const a = duration.split(':');
        return (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
    }

    handleforgotpassword = () => {
        // Keep the address the user already typed. Clearing it here handed them
        // an empty box that the Reset button was happy to submit, and a blank
        // submission reaches the backend's account lookup.
        this.setState({ isForgotPasswordClicked: true, password: '' })
    }
    handlecancelforgotpassword = () => {
        this.setState({ isForgotPasswordClicked: false, loginEmail: '', password: '' })
    }
    handleresetPassword = () => {
        const useremail = this.state.loginEmail.trim().toLowerCase()
        if (useremail === '') {
            toast.error("Please enter your email address.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
            return
        }
        this.setState({ loading: true })
        const resparams = {
            "useremail": useremail
        }
        passwordresetsendemail(resparams).then(res => {
            if (res.status === 200) {
                this.setState({ loading: false })
                if (res.data === "0") {
                    toast.error("Please check entered email address, it does not exist in the system.", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
                else {
                    toast.info("Your password has been successfully reset, and a new password has been sent to your registered email address.", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    this.setState({ isForgotPasswordClicked: false, loginEmail: '', password: '' })
                }
            }
        }).catch(err => {
            // A failed reset used to be completely silent here: the user saw the
            // spinner stop and nothing else, so they stayed locked out without
            // knowing the request had failed.
            console.error(err.message)
            this.setState({ loading: false })
            const serverMessage = err.response && err.response.data && err.response.data.error
            toast.error(serverMessage || "We could not reset your password right now. Please try again, or contact support@aiplato.ai.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })


    }

    renderSignUpLink = () => (
        this.state.showHeader
            ? <Link to="/signUpPlans">Create an account</Link>
            : <a href={WEBSITE_URL + "signUpPlans"}>Create an account</a>
    )

    renderSubscribeLink = () => (
        this.state.showHeader
            ? <Link to="/signUpPlans" className="lp-notice-link">Subscribe Now</Link>
            : <a href={WEBSITE_URL + "signUpPlans"} className="lp-notice-link">Subscribe Now</a>
    )

    renderCardHeader = (title, subtitle) => (
        <div className="lp-card-head">
            <div>
                <h2 className="lp-title">{title}</h2>
                {subtitle ? <p className="lp-subtitle">{subtitle}</p> : null}
            </div>
            {this.props.onClose || this.state.cardPos ?
                <button type="button" className="lp-close" aria-label="Close" onClick={this.handleCloseCard}>&times;</button>
                : null
            }
        </div>
    )

    renderSignInForm = () => {
        const { loginEmail, password, showPassword, signingIn } = this.state;
        return (
            <form className="lp-form" onSubmit={this.getEarlyAccessHandler}>
                {this.renderCardHeader('Welcome back', this.state.showHeader ? 'Sign in to continue to aiPlato.' : null)}

                <div className="lp-field">
                    <label htmlFor="lp-email" className="lp-label">Email or user ID</label>
                    <input
                        id="lp-email"
                        name="email"
                        type="text"
                        className="lp-input"
                        placeholder="you@university.edu"
                        autoComplete="email"
                        autoFocus
                        required
                        value={loginEmail}
                        onChange={this.handleEmailChange}
                    />
                </div>

                <div className="lp-field">
                    <div className="lp-label-row">
                        <label htmlFor="lp-password" className="lp-label">Password</label>
                        <button type="button" className="lp-text-btn" onClick={this.handleforgotpassword}>Forgot?</button>
                    </div>
                    <div className="lp-input-wrap">
                        <input
                            id="lp-password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            className="lp-input lp-input--with-action"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                            required
                            value={password}
                            onChange={(e) => this.setState({ password: e.target.value })}
                        />
                        <button
                            type="button"
                            className="lp-input-action"
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            onClick={this.togglePasswordVisibility}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </button>
                    </div>
                </div>

                {/* Disabled while the sign-in is in flight so a second click cannot fire a
                    second credential check. */}
                <button type="submit" className="lp-primary-btn" disabled={signingIn || loginEmail === ''}>
                    {signingIn ? <><CircularProgress size={16} sx={{ color: '#fff' }} /><span>Signing in…</span></> : 'Sign in'}
                </button>

                {this.state.showTrialExpired && (
                    <div className="lp-notice">
                        <p>Your 7-day free trial has expired. Please subscribe to continue using aiPlato.</p>
                        {this.renderSubscribeLink()}
                    </div>
                )}

                {this.state.showAccessExpired && (
                    <div className="lp-notice">
                        <p>Your access has expired. Pay for Semester Access to keep using aiPlato for the term.</p>
                        <button
                            type="button"
                            className="lp-primary-btn lp-primary-btn--compact"
                            onClick={this.handlePaySemesterFromLogin}
                            disabled={this.state.accessExpiredPaying || loginEmail === ''}
                        >
                            {this.state.accessExpiredPaying ? 'Redirecting…' : 'Pay Semester Access'}
                        </button>

                        {!this.state.showRedeemFromLogin ? (
                            <button
                                type="button"
                                className="lp-text-btn lp-text-btn--underline"
                                onClick={() => this.setState({ showRedeemFromLogin: true, redeemError: '' })}
                            >
                                Already bought a code at the bookstore? Redeem it
                            </button>
                        ) : (
                            // Not a nested <form>: this sits inside the sign-in form, so Enter is
                            // routed to the redeem handler explicitly instead of signing in.
                            <div className="lp-redeem">
                                <input
                                    type="text"
                                    className="lp-input"
                                    aria-label="Access code"
                                    placeholder="Enter your access code"
                                    value={this.state.redeemCode}
                                    onChange={(ev) => this.setState({ redeemCode: ev.target.value, redeemError: '' })}
                                    onKeyDown={(ev) => { if (ev.key === 'Enter') { this.handleRedeemFromLogin(ev); } }}
                                />
                                <div className="lp-redeem-actions">
                                    <button type="button" className="lp-primary-btn lp-primary-btn--compact" onClick={this.handleRedeemFromLogin} disabled={this.state.redeemingFromLogin || loginEmail === ''}>
                                        {this.state.redeemingFromLogin ? 'Redeeming…' : 'Redeem'}
                                    </button>
                                    <button type="button" className="lp-secondary-btn" onClick={() => this.setState({ showRedeemFromLogin: false, redeemError: '', redeemCode: '' })}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        )}
                        {this.state.redeemError ? <p className="lp-error">{this.state.redeemError}</p> : null}
                    </div>
                )}

                <div className="lp-or"><span>OR</span></div>
                {/* <GoogleLoginPage></GoogleLoginPage> */}
                <div className="lp-footer lp-footer--plain">
                    New to aiPlato? {this.renderSignUpLink()}
                </div>
            </form>
        )
    }

    renderForgotPasswordForm = () => (
        <form className="lp-form" onSubmit={(e) => { e.preventDefault(); this.handleresetPassword(); }}>
            {this.renderCardHeader('Reset password', "Enter your email and we'll send you a new password.")}

            <div className="lp-field">
                <label htmlFor="lp-reset-email" className="lp-label">Email address</label>
                <input
                    id="lp-reset-email"
                    name="email"
                    type="text"
                    className="lp-input"
                    placeholder="you@university.edu"
                    autoComplete="email"
                    autoFocus
                    required
                    value={this.state.loginEmail}
                    onChange={this.handleEmailChange}
                />
            </div>

            <button type="submit" className="lp-primary-btn" disabled={this.state.loading || this.state.loginEmail.trim() === ''}>
                {this.state.loading ? <><CircularProgress size={16} sx={{ color: '#fff' }} /><span>Sending…</span></> : 'Reset password'}
            </button>

            <div className="lp-footer">
                <button type="button" className="lp-text-btn" onClick={this.handlecancelforgotpassword}>&larr; Back to sign in</button>
            </div>
        </form>
    )

    render() {
        if (this.state.hasAutoLogin) {
            return null;
        }

        const content = this.state.isForgotPasswordClicked ? this.renderForgotPasswordForm() : this.renderSignInForm();

        if (!this.state.showHeader) {
            return <div className="lp-card lp-card--popover">{content}</div>;
        }

        const { cardPos } = this.state;

        return (
            <div className='fwidth lp-screen'>
                <div className="banner-pt container-fluid bg-gray1 pb-4">
                    <Container className="gradientBannerBg lp-hero">
                        <div className='lp-hero-text'>
                            <h1>AI Teaching Assistant for STEM</h1>
                            <h3>Developed by Educators, for Educators</h3>
                        </div>
                    </Container>
                </div>

                {cardPos ? <div className="lp-dim" aria-hidden="true" /> : null}

                <div className={cardPos ? "lp-anchor" : "lp-page"}
                    style={cardPos ? { top: cardPos.top, right: cardPos.right, '--lp-arrow-right': `${cardPos.arrowRight}px` } : undefined}>
                    <div className={cardPos ? "lp-card lp-card--popover" : "lp-card"}
                        style={cardPos ? { maxHeight: `calc(100vh - ${cardPos.top + 16}px)` } : undefined}>
                        {content}
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(Login);
